import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  private router = inject(Router);

  orderType: 'ordonnance' | 'catalogue' = 'ordonnance';
  adresseLivraison = 'Rue des Jardins, Cocody';
  selectedFile: File | null = null;

  partnerPharmacies = [
    { nom: 'Pharm. de la Paix', note: 4.8, distance: 1.2 },
    { nom: 'Pharm. du Plateau', note: 4.6, distance: 2.0 },
    { nom: 'Pharm. Riviera', note: 4.7, distance: 3.1 },
  ];

  setOrderType(type: 'ordonnance' | 'catalogue') {
    this.orderType = type;
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
    }
  }

  handleContinue() {
    if (this.orderType === 'ordonnance') {
      // Navigate to prescription flow or handle uploading/saving state
      this.router.navigate(['/prescription/upload'], {
        queryParams: { address: this.adresseLivraison }
      });
    } else {
      // Go directly to Catalog
      this.router.navigate(['/catalog']);
    }
  }
}
